import Vue from 'vue'
import Vuelidate from 'vuelidate'
import sugar from 'sugar'

sugar.extend()

import App from './App'
import Vuetify from 'vuetify'
import Cookies from 'js-cookie'
import router from './router'
import store from './store'

import locales from './locales'

import VueQrcode from '@chenfengyuan/vue-qrcode'
import '@/assets/styles/index.scss'
import 'vuetify/dist/vuetify.min.css'
import alerts from '@/components/Alerts'
Vue.config.productionTip = false

// COMPONENTS

import VueGoogleApi from 'vue-google-api'
import VueMask from 'v-mask'
import SocialSharing from 'vue-social-sharing'

const config = {
    clientId: process.env.VUE_APP_GOOGLE
}

// COMPONENTS
Vue.use(VueGoogleApi, config)
Vue.use(VueMask)
Vue.use(SocialSharing)

import Locale from '@/components/Locale/v-locale'

import DatePicker from '@/components/DatePicker/date-picker'
import TimePicker from '@/components/TimePicker/time-picker'
import Loader from '@/components/Loader/loader'

import '@/filters'

Vue.use(Vuetify, {
    lang: {
        locales,
        current: Object.keys(locales).includes(Cookies.get('language')) ? Cookies.get('language') : 'ru'
    }
})

Vue.use(Vuelidate)
Vue.use(VueMask)

Vue.component('v-locale', Locale)

Vue.component('v-alerts', alerts)
Vue.component('v-picker', DatePicker)
Vue.component('time-picker', TimePicker)
Vue.component('v-loader', Loader)
Vue.component(VueQrcode.name, VueQrcode)

export default new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App)
})
